<template>
  <div style>
    <div style="height:80px; position:fixed; background:#fff; z-index:100; width:100%;" >
      
        <div class="animated-med" style="max-width:1200px; height:100px; width:100%;">
          <transition mode="out-in" enter-active-class="fadeInUp" leave-active-class="fadeOutDown">
            <div
              v-if="loaded"
              class="animated-med ourlatest"
              
              
            >OUR<b style="font-weight:700">LATEST</b>WORK</div>
          </transition>
          <transition mode="out-in" enter-active-class="fadeInUp" leave-active-class="fadeOutDown"></transition>
        </div>
      
    </div>

    <div class="tiles">
      <Tile v-for="(item, i) in tiles" :key="i" :title="item.title" :link="item.link" :year="item.year" :src="item.src"></Tile>
    </div>
  </div>
</template>
<script>
import Tile from "./tile";
export default {
  name: "about",
  data() {
    return {
      loaded: false,
      loaded2: false,
      tiles: [
        { title: "Cut Throat City", link:'cut_throat_city', year: "2016", src: "1.jpg" },
        { title: "Threshold",link:'threshold', year: "2016", src: "2.jpg" },
        { title: "Blackway",link:'blackway', year: "2016", src: "3.jpg" },
        { title: "Wakefield",link:'wakefield', year: "2016", src: "4.jpg" },
        { title: "Office Uprising",link:'office_uprising', year: "2016", src: "5.jpg" },
        { title: "Stealing Cars",link:'stealing_cars', year: "2016", src: "6.jpg" },
        { title: "Daisy Winters ",link:'daisy_winters', year: "2017", src: "7.jpg" }
      ]
    };
  },
  components: {
    Tile
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true;
    }, 300);
    setTimeout(() => {
      this.loaded2 = true;
    }, 500);
  }
};
</script>
<style scoped>
.tiles{
  background: #fff;
  display:flex;
  flex-wrap: wrap;
  padding:10%;
}
.ourlatest{
font-size:25pt; color:#000 !important; letter-spacing:2px; max-width:45%; font-weight:200; padding:15px; margin-bottom:20px;
}
@media(max-width:720px){
  .ourlatest{
    font-size: 19pt;
    padding: 22px 10px;
  }
  .tiles{
    padding:0;
    padding-top: 70px;
  }
}
.dots {
  height: 100%;
  width: 100%;
  left: 0;
  position: absolute;
  background: url("https://conductorproductions.com/wp-content/plugins/revslider/public/assets/assets/gridtile_3x3.png");
  background-color: #000000aa;
  background-repeat: repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.about-container {
  height: 2000px;
  width: 100%;

  /* background: url("../../img/rumbleboys.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat; */
}

</style>